// MUI
import { Box, Stack } from "@mui/material";

// Components
import AnimatedNavbar from "./AnimatedNavbar";
import { HeaderActions, IHeaderActionsProps } from "./HeaderActions";
import { HeaderLogoSection } from "./HeaderLogoSection";

const HeaderAppBar = (props: Readonly<IHeaderActionsProps>) => {
	return (
		<Stack className="h-[55px] bg-gradient-to-r from-[#E31F75] via-[#4C0C69] to-[#068CCD]">
			<Stack className="w-[1440px] m-auto h-full z-10">
				<Stack direction={"row"} className="h-full">
					<Box className="flex w-96 h-full !justify-start items-center">
						<HeaderLogoSection />
					</Box>
					<Box className="flex flex-1 h-full items-center">
						<AnimatedNavbar />
					</Box>
					<Box className="flex w-96 h-full !justify-end">
						<HeaderActions onLogoutAction={props.onLogoutAction} />
					</Box>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default HeaderAppBar;
